import React, { useMemo, useRef, useState } from 'react'

import { LabelProps } from './Label.types'
import Tooltip from '../../Tooltip/Tooltip'
import merge from 'lodash/merge'
const Label: React.FC<LabelProps> = ({
    hide,
    tooltip,
    tooltipProps = {},
    htmlFor,
    width,
    text,
    isRequired,
    children,
    style = {},
    onClick = () => {},
}) => {
    const ref = useRef(null)
    const [isMouseOver, setIsMouseOver] = useState(false)
    const classNames = () => {
        const c = ['r-label-container']
        if (isRequired) {
            c.push('r-state-required')
        }

        if (tooltip) {
            c.push('r-color-blue-d1')
        }

        return c.join(' ')
    }

    const _style = {
        width,
    }

    if (hide) {
        return null
    }

    const label = useMemo(() => {
        return (
            <label
                onClick={onClick}
                htmlFor={htmlFor}
                style={merge(_style, style)}
                data-testid='Label'
                className={classNames()}
            >
                {text || children}
            </label>
        )
    }, [text])

    if (tooltip) {
        return (
            <Tooltip
                type={'dark'}
                positioning={[0, 2]}
                vertical={'bottom'}
                pos={'left'}
                {...tooltipProps}
                content={tooltip}
                color={'#fff'}
                backgroundColor={'#37002d'}
            >
                {(ref) => (
                    <label
                        ref={ref}
                        onClick={onClick}
                        htmlFor={htmlFor}
                        style={merge(_style, style)}
                        data-testid='Label'
                        className={classNames()}
                    >
                        {text || children}
                    </label>
                )}
            </Tooltip>
        )
    }

    return label
}

export default Label
